if (!customElements.get('subscription-popup')) {
  customElements.define(
    'subscription-popup',
    class SubscriptionPopup extends DrawerComponent {
      // WICHTIG: data-trigger-open / data-repeat-open / data-delay-seconds
      // duerfen NICHT observiert werden. attributeChangedCallback der
      // Basisklasse feuert beim Element-Upgrade noch vor connectedCallback
      // und kann das Drawer dadurch sofort oeffnen.
      static get observedAttributes() {
        return super.observedAttributes;
      }

      get requiresBodyAppended() {
        return false;
      }

      connectedCallback() {
        super.connectedCallback();

        this.cookieName = 'sleektheme:popup';
        this.triggerOpen = this.normalizeTrigger(this.dataset.triggerOpen);
        this.repeatOpen = this.dataset.repeatOpen;
        this.delaySeconds = this.parseDelay(this.dataset.delaySeconds);

        this.openTimeout = null;
        this.scrollHandler = null;

        this.whenReady(this.handleOpen.bind(this));

        window.FoxTheme.utils.addEventDelegate({
          context: this,
          selector: '.btn-apply-coupon-code',
          handler: async (e, target) => {
            e.preventDefault();

            const code = target.dataset.code;

            if (code) {
              this.copyToClipboard(code, target);
            }
          },
        });
      }

      disconnectedCallback() {
        if (typeof super.disconnectedCallback === 'function') {
          super.disconnectedCallback();
        }

        this.clearPendingTriggers();
      }

      clearPendingTriggers() {
        if (this.openTimeout) {
          clearTimeout(this.openTimeout);
          this.openTimeout = null;
        }

        if (this.scrollHandler) {
          window.removeEventListener('scroll', this.scrollHandler);
          this.scrollHandler = null;
        }
      }

      // Faengt alte, im Theme gespeicherte Werte ab. Sonst faellt ein
      // unbekannter Wert in den default-Case und das Popup oeffnet sofort.
      normalizeTrigger(value) {
        const raw = (value || '').toString().trim().toLowerCase();

        if (raw === 'delay' || raw === 'scroll_down' || raw === 'immediately') {
          return raw;
        }

        if (raw.indexOf('scroll') !== -1) return 'scroll_down';
        if (raw.indexOf('delay') !== -1) return 'delay';
        if (raw.indexOf('immediate') !== -1 || raw.indexOf('load') !== -1) {
          return 'immediately';
        }

        console.warn(
          '[subscription-popup] Unbekannter trigger_open-Wert:',
          value,
          '– es wird auf "delay" zurueckgefallen. Section im Theme-Editor neu speichern.'
        );

        return 'delay';
      }

      parseDelay(value) {
        const parsed = parseInt(value, 10);

        if (!Number.isFinite(parsed) || parsed < 0) {
          return 45;
        }

        return parsed;
      }

      // FoxTheme.DOMready haengt sich an DOMContentLoaded und feuert bei
      // bereits fertigem DOM (z.B. Section Rendering API) nicht mehr.
      whenReady(callback) {
        if (document.readyState === 'loading') {
          window.FoxTheme.DOMready(callback);
        } else {
          callback();
        }
      }

      alreadyOpened() {
        const savedData = window.FoxTheme.utils.getStorage(this.cookieName);

        return Boolean(savedData && savedData.opened);
      }

      prepareToShow() {
        super.prepareToShow();
        this.clearPendingTriggers();
        this.setRepeatOpen();
      }

      handleOpen() {
        if (Shopify.designMode) return;
        if (this.alreadyOpened()) return;

        switch (this.triggerOpen) {
          case 'delay':
            this.openTimeout = setTimeout(() => {
              this.openTimeout = null;

              // Zwischenzeitlich in einem anderen Tab geoeffnet?
              if (this.alreadyOpened()) return;

              this.show();
            }, this.delaySeconds * 1000);

            break;

          case 'scroll_down':
            this.triggerAfterScroll(700, this.show.bind(this));
            break;

          case 'immediately':
            this.show();
            break;
        }
      }

      triggerAfterScroll(offset = 500, trigger) {
        const start = 0;

        this.scrollHandler = () => {
          const scrollTop =
            window.pageYOffset ||
            (document.documentElement || document.body.parentNode || document.body)
              .scrollTop;

          if (scrollTop - start <= offset) return;

          window.removeEventListener('scroll', this.scrollHandler);
          this.scrollHandler = null;

          if (this.alreadyOpened()) return;

          trigger();
        };

        window.addEventListener('scroll', this.scrollHandler, { passive: true });
      }

      copyToClipboard(code, button) {
        navigator.clipboard.writeText(code);
        button.innerText = button.dataset.copiedText;
      }

      setRepeatOpen() {
        if (Shopify.designMode) return;

        let expires;

        switch (this.repeatOpen) {
          case 'no_repeat':
            expires = 365;
            break;

          case 'every_3_mins':
            expires = 3 / 60 / 24;
            break;

          case 'every_5_mins':
            expires = 5 / 60 / 24;
            break;

          case 'every_10_mins':
            expires = 1 / 6 / 24;
            break;

          case 'every_15_mins':
            expires = 15 / 60 / 24;
            break;

          case 'every_30_mins':
            expires = 1 / 2 / 24;
            break;

          case 'every_1_hr':
            expires = 1 / 24;
            break;

          case 'every_6_hrs':
            expires = 6 / 24;
            break;

          case 'every_12_hrs':
            expires = 1 / 2;
            break;

          case 'every_day':
            expires = 1;
            break;

          case 'every_3_days':
            expires = 3;
            break;

          case 'every_week':
            expires = 7;
            break;

          case 'every_2_weeks':
            expires = 14;
            break;

          case 'every_month':
            expires = 30;
            break;

          default:
            expires = 7;
            break;
        }

        window.FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
      }
    }
  );
}